module.exports = "/packs/media/images/icons/savingstree-076827560f592bc0e8af129c72b90d4e.png";